module.exports = __webpack_public_path__ + "static/img/app-logo.e9f1128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app-logo.png
// module id = Vg9C
// module chunks = 2